import { toFolder } from './mappers/folder';
import { allCategories } from './data/all-categories';
import { MediaType } from '../../constants/MediaType';
export function initFolders() {
  function list() {
    return Promise.resolve({
      data: allCategories.map(item => toFolder(item, MediaType.Picture))
    });
  }
  return {
    list
  };
}